const SectionHeading = ({ icon, name, className, children }) => {
    return (
        <div
            className={`bg-gray-150 rounded-lg p-4 flex items-center ${className}`}
        >
            {!!icon && (
                <div className="w-6 h-6 text-primary-700 mr-3">{icon}</div>
            )}
            <div className="text-lg font-medium flex-1">
                {name}
                {!!children && (
                    <div className="font-normal text-base">{children}</div>
                )}
            </div>
        </div>
    );
};

export default SectionHeading;
